import { isNullOrBlank, isNullOrUndefined } from "./index";
export const DECIMALS_ONLY_REGEX = /^\s*-?[0-9]\d*(\.\d{1,2})?\s*$/;
export const NUMBERS_ONLY_REGEX = /^\d+$/;
export const validateEmail = (rule, value) => {
    if (!value || value.length === 0) {
        return Promise.resolve(); // No value - use required rule for required fields
    }
    // https://emailregex.com/
    const emailRegEx = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
    if (value && value.length > 0 && emailRegEx.exec(value)) {
        return Promise.resolve();
    }
    return Promise.reject("Invalid email address");
};
export const validateEmailCsv = (rule, value) => {
    if (!value || value.length === 0) {
        return Promise.resolve(); // No value - user required rule for required fields
    }
    // This RegEx is duplicated in @EmailCsv annotation for server side validation
    const csvEmailRegEx = /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/;
    if (value && value.length > 0 && csvEmailRegEx.exec(value)) {
        return Promise.resolve();
    }
    return Promise.reject("Invalid email address, multiple email addresses can be separated by a comma.");
};
export const validateEqualToOrGreaterThanZero = (rule, value) => {
    if (!value) {
        return Promise.resolve();
    }
    const parsedValue = parseFloat(value);
    if (!DECIMALS_ONLY_REGEX.test(value) || isNaN(parsedValue) || !isFinite(parsedValue)) {
        return Promise.reject(new Error('Value needs to be a number'));
    }
    if (parsedValue < 0) {
        return Promise.reject(new Error('Value must not be negative'));
    }
    return Promise.resolve();
};
export const validateGreaterThanZero = (rule, value) => {
    if (isNullOrUndefined(value) || isNullOrBlank(value)) {
        return Promise.resolve();
    }
    const parsedValue = parseFloat(value);
    if (!DECIMALS_ONLY_REGEX.test(value) || isNaN(parsedValue) || !isFinite(parsedValue)) {
        return Promise.reject(new Error('Value needs to be a number'));
    }
    if (parsedValue <= 0) {
        return Promise.reject(new Error('Value must be greater than 0'));
    }
    return Promise.resolve();
};
export const validateWholeNumber = (rule, value) => {
    if (!value) {
        return Promise.resolve();
    }
    const parsedValue = parseFloat(value);
    if (!NUMBERS_ONLY_REGEX.test(value) || isNaN(parsedValue) || !isFinite(parsedValue) || value % 1 !== 0) {
        return Promise.reject(new Error('Value needs to be a number'));
    }
    return Promise.resolve();
};
export const validateNotEqualToZero = (rule, value) => {
    if (value === 0) {
        return Promise.reject(new Error('Value must not be zero'));
    }
    if (!value) {
        return Promise.resolve();
    }
    const parsedValue = parseFloat(value);
    if (!DECIMALS_ONLY_REGEX.test(value) || isNaN(parsedValue) || !isFinite(parsedValue)) {
        return Promise.reject(new Error('Value needs to be a number'));
    }
    if (parsedValue === 0) {
        return Promise.reject(new Error('Value  must not be zero'));
    }
    return Promise.resolve();
};
export const validateABN = (rule, value) => {
    if (!value) {
        return Promise.resolve();
    }
    //value = value.replace(/[^0-9]/g, '');
    const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
    if (value.length === 11) {
        let sum = 0;
        weights.forEach(function (weight, position) {
            let digit = value[position] - (position ? 0 : 1);
            sum += weight * digit;
        });
        if (sum % 89 == 0) {
            return Promise.resolve();
        }
    }
    return Promise.reject(new Error('Invalid ABN.  Enter ABN with no spaces or special characters'));
};
